import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/invoiceNotifications`;

export const ROUTE: RouteDefinition = `${baseRoute}/invoiceNotifications`;

export const URL = (): RouteDefinition => `${baseRoute}/invoiceNotifications`;
